export default __webpack_public_path__ + "static/media/1f.41cc6931.jpg";